<div [ngClass]="fromDialog?'':'fullScreen'">
  <ng-container *ngIf="!this.fromDialog">
    <vias-breadcrumb [breadcrumbs]="this.breadcrumbs"></vias-breadcrumb>
    <br>
  </ng-container>
  <ng-container *ngIf="this.fromDialog">
    <h2>{{moduleName |translate}} - {{pageName |translate}}</h2>
  </ng-container>
  <vias-datagrid
    [dataSource]="dataSource"
    [numLocale]="numLocale"
    [columns]="columns"
    [currentPage]="pageno"
    [totalPages]="totalPages"
    [options]="datagridOptions"
    [rowClassRules]="rowClassRules"
    [tableId]="datagridId"
    [sideMenuItems]="sideMenuItems"
    [statusBarItems]="statusBarItems"
    [contextMenuItems]="contextMenuItems"
    (refresh)="datagridRefreshHandler($event)"
    (rowClick)="datagridClickHandler($event)"
    (dblClick)="datagridDoubleClickHandler($event)"
    (selectClick)="datagridSelectBtnClickHandler($event)"
    (addClick)="datagridAddBtnClickHandler($event)"
    (editClick)="datagridEditBtnClickHandler($event)"
    (deleteClick)="datagridDeleteBtnClickHandler($event)"
    [columnState]="datagridColumnState"
    (columnStateChange)="datagridColumnStateChangeHandler($event)"
    (cellChange)="datagridCellChangeHandler($event)"
    *ngIf="hasDatagrid"
    [dgButtons]="dgButtons"
    [enableCharts]="enableCharts"
  ></vias-datagrid>
  <vias-buttonbar
    [numLocale]="numLocale"
    [buttons]="buttonBarItems"
    (itemClick)="butonclickHandler($event)"
    *ngIf="hasButtonbar"
  ></vias-buttonbar>
  <vias-form 
    #form
    [tabs]="tabs"
    [tabSelectedIndex]="tabSelectedIndex"
    [hasSubmitBtn]="hasSubmitBtn"
    [submitBtnText]="submitBtnText"
    [numLocale]="numLocale"
    [formItems]="formItems"
    (formChange)="formChangeHandler($event)"
    (formSubmit)="formSubmitHandler($event)"
    (formItemClick)="formItemClickHandler($event)"
    (tabSelectedIndexChange)="tabSelectedIndexChange($event)"
    *ngIf="hasEditForm"
  ></vias-form>
</div>